<template lang="pug">
section#app
  #layout
    bh-header(ref="bhHeader",
      :displayMainHeader="displayMainHeader",
      :displayDebutHeader="displayDebutHeader",
      :displayCompanyHeader="displayCompanyHeader")
    div(v-bind:class="{ onHeaderfixed: scrollTop > 60, container: includeContainer() }")
      router-view(transition="app-layout")
    #layout_footer(v-if="displayFooter")
  bh-footer(:displayFooter="displayFooter")

  user-offcanvas(ref="userOffcanvas", v-if="offCanvas")
  menu-offcanvas(ref="menuOffcanvas", v-if="offCanvas")

  login-modal
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { aside, accordion, panel } from 'vue-strap'
import gaExt from 'utilities/gaExt'

import loginModal from 'components/loginModal.vue'
import bhHeader from 'components/bhHeader.vue'
import menuOffcanvas from 'components/menuOffcanvas.vue'
import userOffcanvas from 'components/userOffcanvas.vue'
import bhFooter from 'components/bhFooter.vue'

export default {
  components: {
    accordion: accordion,
    panel: panel,
    vAside: aside,
    loginModal: loginModal,
    menuOffcanvas: menuOffcanvas,
    userOffcanvas: userOffcanvas,
    bhHeader: bhHeader,
    bhFooter: bhFooter
  },
  created () {
    window.addEventListener('scroll', (event) => {
      this.scrollTop = isNaN(window.scrollTop) ? window.pageYOffset : window.scrollTop
    }, false)

    window.addEventListener('resize', this.windowResizer, false)

    // if (typeof this.$route.query !== 'undefined') {
    //   if (typeof this.$route.query.token !== 'undefined') {
    //     let newQueries = JSON.parse(JSON.stringify(this.$route.query))
    //     delete newQueries.token

    //     let newPath = this.$route.path.replace(/token=[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*/gim, '').replace('?&', '?')
    //     newPath = newPath.substr(-2) === '/?' ? newPath.substr(newPath.length - 1) : newPath
    //     this.$router.push(newPath)
    //   }
    // }
  },
  mounted () {
    this.offCanvas = window.innerWidth <= 991
    this.windowResizer()

    let gaOptions = {
      trackingID: process.env.GA
    }
    if (typeof this.getUserData !== 'undefined') {
      if (typeof this.getUserData.uid !== 'undefined' && typeof this.getUserData.email !== 'undefined') {
        if (typeof window.amplitude !== 'undefined') {
          window.amplitude.getInstance().setUserId(this.getUserData.uid)
          window.amplitude.getInstance().setUserProperties({
            email: this.getUserData.email
          })
        }

        gaOptions = {
          trackingID: process.env.GA,
          userId: this.getUserData.uid
        }
      }
    }

    gaExt.init(gaOptions)
  },
  data () {
    let locale = 'tw'
    if (typeof this.$route.params !== 'undefined' &&
      typeof this.$route.params.locale !== 'undefined') {
      locale = this.$route.params.locale
    }

    return {
      locale: locale,
      scrollTop: 0,
      gaOptions: {
        trackingID: process.env.GA
      },
      offCanvas: false,
      displayMainHeader: false,
      displayDebutHeader: false,
      displayCompanyHeader: false,
      displayFooter: false
    }
  },
  watch: {
    '$store.state.route.meta' (meta) {
      if (typeof meta.displayMainHeader !== 'undefined') {
        this.displayMainHeader = meta.displayMainHeader
      }
      if (typeof meta.displayDebutHeader !== 'undefined') {
        this.displayDebutHeader = meta.displayDebutHeader
      }
      if (typeof meta.displayCompanyHeader !== 'undefined') {
        this.displayCompanyHeader = meta.displayCompanyHeader
      }
      if (typeof meta.displayFooter !== 'undefined') {
        this.displayFooter = meta.displayFooter
      }
    }
  },
  computed: mapGetters({
    getUserData: 'users/getUserData',
    getToken: 'users/getToken',
    isShowMenuSidebar: 'utilities/isShowMenuSidebar',
    isShowUserSidebar: 'utilities/isShowUserSidebar'
  }),
  methods: {
    // displayMainHeader () {
    //   if (typeof this.$route.meta.displayMainHeader === 'undefined') {
    //     return true
    //   }
    //   return typeof this.$route.meta.displayMainHeader === 'boolean' ? this.$route.meta.displayMainHeader : true
    // },
    // displayDebutHeader () {
    //   if (typeof this.$route.meta.displayDebutHeader === 'undefined') {
    //     return true
    //   }
    //   return typeof this.$route.meta.displayDebutHeader === 'boolean' ? this.$route.meta.displayDebutHeader : true
    // },
    // displayCompanyHeader () {
    //   if (typeof this.$route.meta.displayCompanyHeader === 'undefined') {
    //     return false
    //   }
    //   return typeof this.$route.meta.displayCompanyHeader === 'boolean' ? this.$route.meta.displayCompanyHeader : false
    // },
    // displayFooter () {
    //   if (typeof this.$route.meta.displayFooter === 'undefined') {
    //     return true
    //   }
    //   return typeof this.$route.meta.displayFooter === 'boolean' ? this.$route.meta.displayFooter : true
    // },
    includeContainer () {
      if (typeof this.$route.meta.noContainer === 'undefined') {
        return false
      }
      return typeof this.$route.meta.noContainer === 'boolean' ? !this.$route.meta.noContainer : true
    },
    windowResizer () {
      this.$nextTick(() => {
        this.offCanvas = window.innerWidth <= 991
        this.$refs.bhHeader.offCanvas = this.offCanvas
      })
    },
    ...mapActions({
      setUserToken: 'users/setUserToken',
      fetchUserData: 'users/fetchUserData'
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResizer, false)
  }
}
</script>

<style lang="sass">
@import '~globalStyles/variables'

[v-cloak]
  display: none
.app-layout-transition
  transition: all .5s ease
.app-layout-enter,
.app-layout-leave
  opacity: 0
  transform: translate3d(20px, 0, 0)

html
  box-sizing: border-box

*, *:before, *:after
  box-sizing: inherit

img
  max-width: 100%

html, body
  width: 100%
  max-width: 100%
  background-color: $background
  color: $black
  font-size: 14px
  -moz-osx-font-smoothing: grayscale
  -webkit-font-smoothing: antialiased
  // @media screen and (max-width: $breakpoint-sm)
  //   -webkit-transform: translate3d(0, 0, 0)
  //   transform: translate3d(0, 0, 0)

#app
  height: 100%

header + .container
  padding-top: 20px

header
  position: relative
  z-index: 1

header.fixed + .container
  padding-top: 70px

.onHeaderfixed

// Select button use original select DOM.
.select-button
  &::after
    border: 1px solid #363636
    border-right: 0
    border-top: 0
    content: " "
    display: block
    height: 7px
    pointer-events: none
    position: absolute
    transform: rotate(-45deg)
    width: 7px
    margin-top: -6px
    right: 16px
    top: 50%
  select
    -webkit-appearance: none
    -webkit-box-align: center
    -webkit-box-pack: start
    align-items: center
    background-color: white
    border: 1px solid #dbdbdb
    border-radius: 3px
    color: #363636
    font-size: 14px
    height: 32px
    justify-content: flex-start
    line-height: 24px
    padding-left: 8px
    position: relative;
    vertical-align: top
    cursor: pointer
    display: block
    outline: none
    padding-right: 36px

// Sweet Alert 2 overwrite bootstrap .fade setting.
.swal2-container.fade
  opacity: inherit

// blog color fixed
.tc-black
  color: #000000
.tc-red-500
  color: #F44336
.tc-red-900
  color: #B71C1C
.tc-purple-500
  color: #9C27B0
.tc-deep-purple-500
  color: #673AB7
.tc-blue-500
  color: #2196F3
.tc-green-500
  color: #4CAF50
.tc-amber-500
  color: #FFC107
.tc-orange-500
  color: #FF9800
.tc-brown-500
  color: #795548
.tc-deep-purple-500
  color: #673AB7

.text-black
  color: $black
.text-green
  color: $green
.text-orange
  color: $orange
.text-red
  color: $red
.text-yellow
  color: $yellow
.text-brown
  color: $brown

.glyphicon-spin
  -webkit-animation: spin 2000ms infinite linear
  animation: spin 2000ms infinite linear

@-webkit-keyframes spin
  0%
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)

  100%
    -webkit-transform: rotate(359deg)
    transform: rotate(359deg)


@keyframes spin
  0%
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)

  100%
    -webkit-transform: rotate(359deg)
    transform: rotate(359deg)

@keyframes ellipsis
  to
    width: 1.25em

//Globe-fixed for {{{ raw html }}}
.competition__content
  h1, h2, h3, h4, h5
    font-weight: bold
    display: block
    +clearfix
  img
    max-width: 100%
    height: auto

ul.style-none
  list-style: none
  padding: 0
  margin-bottom: 0
  li > ul
    list-style: none
    padding: 0
    margin-bottom: 0
  li
    &.item-pull-left
      display: inline-block
      margin-right: 20px

.pointer
  cursor: pointer

.btn-blank

.adunit,
  clear: both

.btn-menu
  background-color: transparent
  color: $yellow
  &:hover
    color: $yellow

.btn-outline
  border: 1px solid #fff

.aside
  overflow-x: hidden !important
  .aside-header
    height: 70px
    padding: 16px 15px !important
    background-color: #000 !important
    background-image: none !important
    font-weight: bold
    border-bottom: 0 !important
    @media (max-width: 370px)
        height: 64px
  .aside-content
    .aside-body
      padding: 0
      .btn-nav, .panel-title
        padding: 20px 10px !important
        text-align: left !important
        border-bottom: 1px solid #ddd
        font-weight: bold
      .panel-title
        &:after
          content: "\25BC"
      .panel-body
        border: 0
        .btn-sub-menu
          padding: 14px 20px !important
          text-align: left !important
          color: $black !important
  .mobile-menu
    padding-left: 12.5%
    padding-right: 12.5%
    h2.user-menu--header
      text-align: center
      border-bottom: 1px solid #fff
      padding-bottom: 20px
      color: $white
      &.user-menu--header-organizer
        margin-top: 70px
      &:after
        content: "\25B2"
        color: $white
        font-size: 15px
        margin-left: 6px
      &.openSub:after
        content: "\25BC"
        color: $white
        font-size: 15px
        margin-left: 6px
    ul.mobile-menu--header
      // list-style: none
      padding-left: 0px
      text-align: center
      border-bottom: 1px solid $white
      @media screen and (max-width: 320px)
        overflow: auto
      li
        padding-top: 1rem
        padding-bottom: 1rem
        display: inline-block
        @media screen and (max-width: 320px)
          padding-top: 20px
          padding-bottom: 20px
          width: 100%
        a
          text-decoration: none
          color: $white
          font-size: 20px
        @media screen and (max-width: $breakpoint-vs)
          width: 100%
    .mobile-menu--sub-menu
      text-align: center
      margin: 0
      padding: 0
      a
        display: block
        font-size: 18px
        color: $white
        text-decoration: none
        padding-top: 68px
        @media screen and (max-width: 320px)
          padding-top: 20px
    ul.mobile-user-menu--hunter, ul.mobile-user-menu--organizer
      li
        padding-top: 20px
        text-align: center
        a
          text-decoration: none !important
          color: $white !important
          font-size: 16px
    ul.mobile-user-menu--other
      margin-top: 50px
      margin-buttom: 50px
      li
        padding-top: 20px
        text-align: center
        a
          text-decoration: none !important
          color: $green !important
          font-size: 16px
    .btn-nav, .panel-heading
      font-size: 16px
      font-weight: bold
      color: $black
      background-color: rgba(0, 0, 0, 0.8)
      border-radius: 0
      a
        text-decoration: none !important
        color: $white !important
    .btn-sub-menu
      &:hover
        background-color: $yellow
        color: $black
        border-radius: 0
    .panel.panel-default
      border: none !important
      background-color: $white
      .panel-heading.accordion-toggle
        padding: 0
        h4
          width: 100%
          display: block
          text-align: center
          font-weight: bold !important
          padding: 10px 0
      .panel-collapse
        .panel-body
          padding: 0
          ul
            padding: 0
            margin-bottom: 0
            list-style: none
            li
              a.btn-sub-menu
                padding: 10px
                font-size: 14px
                color: $black
                font-weight: bold
                &:hover
                  color: $black-1

.hr
  width: 100%
  border-top: 1px solid #eee
  box-shadow: 1px 1px 1px rgba($white, 0.8)
  display: block
  margin:
    top: 10px
    bottom: 30px
  &--dark
    border-top: 1px solid $hr

.btn__heart
  color: #ddd
  &:hover
    color: $red
  i.glyphicon.glyphicon-heart
    margin-right: 3px
  .heart__count
    margin-left: 3px
  &--saved
    i.glyphicon.glyphicon-heart
      color: $red
  &--unsaved
    i.glyphicon.glyphicon-heart
      color: $black
.no-content
  font-size: 15px
  font-weight: bold
  padding-right: 0.75em
  color: rgba($brown,0.6)
  text-shadow: 1px 2px 3px $white, 0 0 0 $background, 1px 2px 3px $white
  text-align: center
  padding: 20px 0
  margin: 10px 0 20px 0

.loading
  overflow: hidden
  padding: 20px 0
  margin: 10px 0 20px 0
  +transition(all, 0.3s, ease-out)
  i.glyphicon
    font-size: 23px
    font-weight: bold
    color: rgba($brown,0.6)
    text-shadow: 1px 2px 3px $white, 0 0 0 $background, 1px 2px 3px $white
    margin-bottom: 10px
  &__text
    font-size: 22px
    font-weight: bold
    padding-right: 0.75em
    color: rgba($brown,0.6)
    text-shadow: 1px 2px 3px $white, 0 0 0 $background, 1px 2px 3px $white
    &:after
      overflow: hidden
      display: inline-block
      vertical-align: bottom
      -webkit-animation: ellipsis steps(4, end) 2000ms infinite
      animation: ellipsis steps(4, end) 2000ms infinite
      content: "\2026"
      width: 0px
      position: absolute
  &.loading-hide
    height: 0
    padding: 0
    margin: 0
    .loading__text:after
      display: none

.card
  position: relative
  margin-bottom: 10px
  &--list
    margin-bottom: 20px
    &:hover
      .card__top.cover-img a
        +opacity(1)
      .counts-group
        right: 10px
        +opacity(1)
        @media screen and (max-width: $breakpoint-sm)
          right: 10px
          top: 10px
          +opacity(1)
        @media screen and (max-width: $breakpoint-xs)
          right: 0
          top: 0
          +opacity(1)
  &:after
    +transition(all, 0.3s)
  &--with-animation, &--hide
    +opacity(0)
    transform: transleteY(0)
    +transition(all, 0.3s)
  &--animated
    +opacity(1)
    transform: translateY(5px)
  &--disabled
    cursor: not-allowed
    &:after
      content: ''
      position: absolute
      display: block
      width: 100%
      height: 100%
      background-color: rgba($background,0.8)
    &:hover
      box-shadow: 0 1px 2px rgba(0,0,0,0.15) !important
  &-default
    padding: 10px
    background-color: $white-1
    // border: 1px solid $border
    box-shadow: 0 1px 2px rgba(0,0,0,0.15)
    &:hover
      box-shadow: 0 0 0 2px rgba($brown-1,0.35)
    &.inset
      box-shadow: inset 0 1px 2px rgba($brown,0.5)
  &-invert
    padding: 10px
    background-color: #e3e3e3
    // border: 1px solid $border
    box-shadow: 0 1px 2px rgba(#888,0.5)
    &.inset
      box-shadow: inset 0 1px 2px rgba(#888,0.5)
  &.card-flat
    box-shadow: none !important
  &.no-padding
    padding: 0
    > ul
      padding: 10px
  &.border-radius
    +border-radius(3px)
    +clearfix
  &.no-shadow
    box-shadow: none
    &:hover
      box-shadow: none
  input:focus
    box-shadow: none
  .card__extra-top
    background-color: $light-grey-1
    .btn.btn-blank.pull-left
      padding: 4px 6px
    .title
      font-size: $font-size-4
      color: $brown-1
      &.title--with-padding
        padding: 6px
      &.actived
        color: $black
  .card__top
    &.cover-img
      width: 226px
      height: 170px
      position: relative
      @media screen and (max-width: $breakpoint-xs)
        width: 30%
        height: auto
      a
        display: block
        min-height: 100%
        background:
          color: #eee
          size: cover
          position: center center
          repeat: no-repeat
        padding-top: 74.5283%
        +opacity(0.7)
        +transition(opacity, 0.5s)
        @media screen and (max-width: $breakpoint-sm)
          +opacity(1)
        &.cover-img--default
          background-image: none
    @media screen and (max-width: $breakpoint-xs)
      padding: 10px 6px 10px 10px
      // width: 100%
      // height: auto
  .card__content
    padding: 10px 10px
    background-color: $white-1
    &.no-cover
      max-width: 540px
      padding: 14px 14px
      @media screen and (max-width: $breakpoint-xs)
        // max-width: 100%
      .title
        max-width: 540px

    @media screen and (max-width: $breakpoint-md)
      // min-width: 350px
      max-width: 350px
    @media screen and (max-width: $breakpoint-xs)
      width: 70%
      min-width: 70%
      padding: 3px 3px 3px 0
      div:not(.title)
        text-align: right
    a:hover
      color: $black
    .title
      font-size: $font-size-3
      font-weight: normal
      color: $black
      margin-bottom: 4px
      max-width: 440px
      @media screen and (max-width: $breakpoint-xs)
        font-size: 18px
        height: auto
        overflow: hidden
        text-overflow: ellipsis
        font-weight: bold
        margin-bottom: 1px
        // max-width: 100%
        // padding-top: 30px
    .card__tag__wrap
      @media screen and (max-width: $breakpoint-xs)
        display: none
    ul
      color: #999
      font-size: 13px
      li > span:first-child
        font-weight: normal
        @media screen and (max-width: $breakpoint-xs)
          font-size: 16px
  .counts-group
    position: absolute
    right: 10px
    top: 10px
    +transition(all,0.25s)
    +opacity(1)
    @media screen and (max-width: $breakpoint-xs)
      position: relative
      text-align: left !important
      top: initial
      right: initial
      bottom: initial
      left: initial
      .counts-wrap
        display: inline-block
        margin-left: 3px
        font-size: 12px
        &:first-child
          margin-left: 0
      // top: 10px
      // right: 10px
      // +opacity(1)
      // top: 0
      // right: 0
      // +opacity(1)
      // background-color: rgba($white,0.6)
      // .counts-wrap
        // padding: 10px
        // float: left
        // color: $black
  .counts-wrap
    color: $brown-1
    i
      margin-right: 3px

  .card__extra
    &--block
      clear: both
    &--float
      position: absolute
      bottom: 10px
      right: 10px
    @media screen and (max-width: $breakpoint-sm)
      .btn__heart
        background-color: rgba(white,0.3)
        border-color: rgba($border, 0.3)
        padding: 3px 8px
        i
          vertical-align: text-top
        span
          display: none
      // position: relative
      // clear: both
      // bottom: inherit
      // right: inherit
      // .btn-group
        // display: block
        // .btn
          // display: block
          // border-radius: 0
          // border: none
          // padding: 13px
          // &:first-child
          //   width: 30%
          // &:last-child
          //   width: 70%
          // &:only-child
          //   width: 100%
          // &+ .btn
          //   margin-left: 0
  .card__extra ~ .counts-group
    @media screen and (max-width: $breakpoint-sm)
      display: none
  &--small
    padding: 10px !important
    &:not(:last-child)
      margin-bottom: 0
    &:hover
      box-shadow: none
      background-color: $disabled-bg
      .card__content
        background-color: $disabled-bg
    .card
      &__top
        width: 20% !important
        padding: 3px 10px 3px 0px
      &__content
        width: 80%
        padding: 0
        min-width: 70%
        .title
          font-size: 1.2em
          overflow: hidden
          text-overflow: ellipsis
          max-height: 1.2em
          min-height: 1.2em
        .card__tag
          display: none
        .competition-info
          .totalPrize
            display: none

  &--straight
    // +transform(scale(0.98))
    &.card--list
      margin-bottom: 20px
      padding: 0 6px
      box-shadow: none
      background-color: transparent
      &:hover
        .card__top.cover-img a
          +opacity(1)
      .card__tag
        padding: 2px 3px
        margin-bottom: 8px
        font-size: 12px
        @media screen and (max-width: $breakpoint-sm)
          padding: 1px 6px
          margin-bottom: 10px
          font-size: inherit
      .counts-group
        right: -5px !important
        top: 0 !important
        +opacity(0)
        @media screen and (max-width: $breakpoint-sm)
          right: 0px !important
          top: 0px !important
          +opacity(1)
      &:hover
        .counts-group
          right: 0 !important
          top: 0 !important
          +opacity(1)
    .card__top
      width: 100%
      height: auto
      padding: 0
      &.cover-img
        width: 100%
        height: auto
        background-color: $white
        a
          display: block
          min-height: 100%
          background:
            color: transparent
            size: cover
            position: center center
            repeat: no-repeat
          padding-top: 74.5283%
          +opacity(0.7)
          @media screen and (max-width: $breakpoint-sm)
            +opacity(1)
          &.cover-img--default
            color: #eee
            background-image: none
    .card__content
      width: 100%
      min-width: 100%
      padding: 10px
      .title
        height: 3.05em
        overflow-y: hidden
        text-overflow: ellipsis
        margin-bottom: 10px
        @media screen and (max-width: $breakpoint-sm)
          font-size: 20px
          height: 32px
      div:not(.title)
        text-align: right
      .card__tag__wrap
        display: block
        text-align: left !important
    .counts-group
      position: absolute
      top: 0
      right: 0
      +opacity(1)
      background-color: rgba($white,0.6)
      .counts-wrap
        padding: 10px
        float: left
        color: $black

    .card__extra
      position: relative
      clear: both
      bottom: inherit
      right: inherit
      .btn-group
        display: block
        .btn
          background-color: #FFF
          display: block
          border-radius: 0
          border: none
          border-top: 1px solid #eee
          padding: 8px 6px
          &:first-child
            width: 70%
          &:last-child
            width: 30%
          &:only-child
            width: 100%
          &+ .btn
            margin-left: 0
          @media screen and (max-width: $breakpoint-xs)
            padding: 13px
            &:first-child
              width: 30%
            &:last-child
              width: 70%
            &+ .btn
              margin-left: 0
            &:only-child
              width: 100%
        .btn__heart
          span
            display: inline
// Card--Straight END

ul.nested-list
  margin-left: 3px
  li
    margin-bottom: 8px
    a
      display: block
      color: $black
      font-weight: bold
      font-size: 15px
      margin-bottom: 3px
    ul
      margin-left: calc(1em + 3px)
      li
        margin-bottom: 1px
        a
          color: $black-2
          font-size: 14px

.card__tag
  color: $black
  display: inline-block
  padding: 1px 6px
  margin-bottom: 10px
  &.actived
    color: $white-1
    background-color: $green
  &.disabled
    color: $disabled
    background-color: $disabled-bg
  &.brown
    color: $white-1
    background-color: $brown
  &.orange
    color: $white-1
    background-color: $orange

.filter
  h4
    margin-top: 25px
    margin-bottom: 12px
    font-weight: bold

  hr
    margin: 0 0 12px 0
  li
    margin-bottom: 3px
    &:first-child
      h4
        margin-top: 0
  &.sort
    li
      &.title
      &:not(.title)
        @media screen and (max-width: $breakpoint-sm)
          width: 25%
          padding: 6px 0

.user__wrap
  height: 150px
  position: relative
  @media screen and (max-width: 650px)
    height: 190px

.user
  &__info
    margin-top: 20px
    color: #fff
    i.glyphicon
      margin-right: 6px
    &__avatar
      margin-right: 16px
      position: relative
    &__avatar__img
      position: relative
      background:
        image: url('http://fakeimg.pl/80x80/ddd/')
        position: center center
        size: cover
        repeat: no-repeat
      // width: 100%
      width: 80px
      height: 80px
    &__avatar__btn-wrap
      position: absolute
      bottom: 0
      width: 100%
      .btn
        padding: 3px 0 0 0
        width: 50%
        background-color: #000
        background-color: rgba(#000, 0.6)
        border: none
        +transition(all, 0.3s, ease)
        +border-radius(0)
        i
          margin: 0
          color: #fff
          color: rgba(#fff, 0.6)
          +transition(all, 0.3s, ease)
          font-size: 12px
        &:hover
         i
          color: #fff
          color: rgba(#fff, 1)
    &__country
      font-size: 12px
      color: #fff
      margin:
        top: 13px
        left: 3px
        bottom: 9px
      letter-spacing: 1px
    &__role
      font-size: 12px
      color: #fff
      margin:
        left: 3px
      letter-spacing: 1px
    &__badges-wrap
      float: right
      @media screen and (max-width: 650px)
        float: none
        clear: both
        padding-top: 10px

    &__badges-item
      width: 40px
      height: 40px
      position: relative
      background:
        color: rgba(#fff,0.5)
        size: cover
        position: center center
      +border-radius(50%)
      float: left
      margin: 0 3px
      line-height: 40px
      text-align: center
      // +transition(all,0.3s, ease)
      +opacity(0.45)
      box-shadow: 0px 0px 5px 1px rgba(#000, 0.3)
      &:hover
        .badges__tooltip
          +opacity(1)
          z-index: 99
      @media screen and (max-width: 650px)
        +opacity(1)
        width: 30px
        height: 30px
        line-height: 30px
      &:hover
        +opacity(1)
      &.badges-img
        cursor: help
      &.badges-more
        background-color: rgba(#000,0.3)
        cursor: pointer
        color: #fff
        color: rgba(#fff, 0.8)
        font-weight: bold
        font-size: 16px
        text-align: center
        @media screen and (max-width: 650px)
          background-color: rgba(#000,0.5)
        i
          margin-right: 0
        &:hover
          background-color: rgba(#000,0.5)
          color: rgba(#fff, 1)
      .badges__tooltip
        display: block
        +opacity(0)
        position: absolute
        top: 100%
        left: 0
        padding: 10px
        width: 35rem
        border-radius: 4px
        box-shadow: 0 1px 2px rgba(0,0,0,0.15)
        transform: translate(-50%, 10px)
        background-color: $white
        color: $black
        z-index: 99
        +transition(all,0.3s, ease)
        .content
          line-height: 160%
          text-align: left
          background: $background
          padding: 6px 10px
        &:before
          content: ""
          position: absolute
          top: -8px
          transform: translate(50%, 0px)
          width: 0
          height: 0
          border-style: solid
          border-width: 0 10px 10px 10px
          border-color: transparent transparent #ffffff transparent
        .user__info__badges-item
          margin: 10px auto


    &__content
      &__name
        margin-top: 3px
      &__status
        span
          margin-right: 8px
          small
            margin-left: 3px
            font-weight: bold
            letter-spacing: 1px
    &.page__title
      color: #fff
      margin-top: 6px
      .page--now
        cursor: pointer
        position: relative
        display: inline-block
        padding: 6px
        transform: translateX(-3px)
        z-index: 999
        +border-radius(3px 3px 0 0)
        &.actived:hover
          background-color: rgba(#000, 0.7)
          .dropdown
            display: block

        span
          font-size: 30px
          vertical-align: middle
        i
          margin-left: 6px
          vertical-align: middle
        .dropdown
          background-color: rgba(#000, 0.7)
          color: $white
          li
            a
              color: $white
              &:hover
                text-decoration: none
                &:after
                  content: "\e128"
                  position: relative
                  top: 1px
                  left: 8px
                  display: inline-block
                  font-family: 'Glyphicons Halflings'
                  font-size: 12px
                  font-style: normal
                  font-weight: 400
                  line-height: 1
                  -webkit-font-smoothing: antialiased
                  -moz-osx-font-smoothing: grayscale
  .pattern
    margin: 20px 0
    padding: 0 3px
    +clearfix
    span
      display: block
      float: left
      height: 18px
      margin-right: 8px
      &:before
        content: ""
        display: block
        float: left
        width: 3px
        height: 100%
        margin-right: 6px
      &.green:before
        background-color: $green
      &.blue:before
        background-color: $blue
      &.yellow:before
        background-color: $yellow
      &.grey:before
        background-color: $grey
  .list-wrap
    min-width: 100%
    .list-item
      .card-default
        margin-bottom: 0
        border-bottom: 1px solid #efefef
        z-index: 1
        &:hover
          // border-bottom: 1px solid transparent
          box-shadow: 0 1px 2px rgba(0,0,0,0.15)
        &.with__status-bar:before
          content: ""
          display: block
          position: absolute
          left: 0
          top: 0
          height: calc(100% + 1px)
          width: 3px
        &.status-bar--green:before
          background-color: $green
        &.status-bar--blue:before
          background-color: $blue
        &.status-bar--yellow:before
          background-color: $yellow
        &.status-bar--grey:before
          background-color: $grey
        .cover-img-wrap
          width: 30%
          max-width: 160px
          margin-right: 16px
          // @media screen and (max-width: $breakpoint-xs)
            // width: 30%
          .cover-img
            padding-top: 74.5283%
            background-image: url('http://fakeimg.pl/226x170/ddd/')
            background-repeat: no-repeat
            background-size: cover

        .content
          h4
            margin: 0 0 6px 0
            a
              color: $black
              font-weight: bold
              font-size: 18px
              @media screen and (max-width: $breakpoint-xs)
                line-height: 24px

          .info
            font-size: 12px
            color: $black-2
            span:first-child
              margin-right: 6px
        .btn-default
          font-size: 13px

      &__more
        margin:
          top: 0
          right: 6px
          bottom: 0
          left: 6px
        padding: 12px
        background-color: #F9F9F9
        box-shadow: 0 1px 2px rgba(0,0,0,0.15)

        .cover-img-wrap
          width: 30%
          max-width: 160px
          margin-right: 16px
          .cover-img
            padding-top: 74.5283%
            background-image: url('http://fakeimg.pl/226x170/ddd/')
            background-repeat: no-repeat
            background-size: cover
        .content
          // overflow: hidden
          .pull-right
            .has-dropdown
              margin-left: 3px
              .dropdown
                padding: 0
                right: -5px
                width: 130px
                height: auto
                z-index: 999
                box-shadow: 0 1px 2px rgba(0,0,0,0.15)
                li
                  padding: 8px 0
                  &:hover
                    text-decoration: none
                    background-color: #ddd
          p
            font-size: 12px
            max-width: 70%
            @media screen and (max-width: $breakpoint-sm)
              max-width: 100%
          .card__tag__wrap
            color: $black-2
            .card__tag
              font-size: 12px
              margin-bottom: 3px
              &:hover
                color: $brown

          .card__category
            color: $black-2
            .glyphicon
              margin-right: 2px
              & ~ span
                margin-right: 8px
                vertical-align: middle
                font-size: 12px

.tabs
  &.user__tabs
    position: absolute
    bottom: 0
  .tab
    color: $white
    float: left
    padding: 8px 12px
    cursor: pointer
    font-weight: bold
    +border-radius(6px 6px 0 0)
    +transition(background,0.15s,ease)
    &:hover
      background-color: rgba(#fff,0.3)
    &.actived
      color: $black
      background-color: $background
      .number
        background-color: #fff
        font-weight: 400
    .number
      font-size: 15px
      vertical-align: top
      padding: 2px 4px
      margin-left: 3px

label.custom-checkbox
  margin-bottom: 0
  &.indeterminate
    .visual-checkbox:after
      border: 0 none
      background-color: $pink-1
      height: 3px
      top: 6px
      transform: none
      opacity: 1
  .visual-checkbox
    content: ""
    width: 16px
    height: 16px
    border: 1px solid $border
    display: inline-block
    margin-right: 8px
    line-height: 16px
    cursor: pointer
    position: relative
    margin-top: 4px
    margin-left: 4px
    &:after
      content: ""
      width: 9px
      height: 5px
      position: absolute
      top: 4px
      left: 3px
      border: 3px solid $pink-1
      border-top: none
      border-right: none
      background: transparent
      opacity: 0
      transform: rotate(-45deg)
    + span
      color: $black
      vertical-align: text-bottom
  input[type="checkbox"]
    visibility: hidden
    position: absolute
    left: -9999px
    &:checked
      &+.visual-checkbox:after
        opacity: 1
      &~span
        cursor: pointer
        color: $pink-1
        &.black
          color: $black
  &.white
    .visual-checkbox
      background-color: $white
      border-color: $input-border
      +border-radius(3px)
label
  &.custom-switch
    margin-bottom: 0
    display: none
    position: relative
    display: inline-block
    width: 46px
    height: 22px
    bottom: -6px
    margin-left: 12px
    &.fixed-margin
      margin-bottom: 5px
      margin-left: 0
    input
      display: none
    .slider
      position: absolute
      cursor: pointer
      top: 0
      left: 0
      right: 0
      bottom: 0
      background-color: $light-grey
      -webkit-transition: .4s
      transition: .4s
      &:before
        position: absolute
        content: ""
        height: 18px
        width: 18px
        left: 4px
        bottom: 2px
        background-color: $white
        -webkit-transition: .4s
        transition: .4s
    input
      &:checked + .slider
        background-color: $light-green-1
      &:focus + .slider
        box-shadow: 0 0 1px $light-grey
      &:checked + .slider:before
        background-color: $white
        -webkit-transform: translateX(20px)
        -ms-transform: translateX(20px)
        transform: translateX(20px)
  .slider.round
    border-radius: 34px
    &:before
      border-radius: 50%
label.custom-radio
  margin-bottom: 0
  .visual-radio
    content: ""
    width: 16px
    height: 16px
    border: 1px solid $border
    display: inline-block
    margin-right: 3px
    line-height: 16px
    cursor: pointer
    position: relative
    margin-top: 4px
    margin-left: 4px
    +border-radius(50%)
    &:after
      content: ""
      width: 8px
      height: 8px
      position: absolute
      top: 3px
      left: 3px
      background-color: $pink-1
      border-radius: 4px
      opacity: 0
    &.useCheck
      &:after
        content: ""
        position: absolute
        opacity: 0
        width: 9px
        height: 5px
        top: 4px
        left: 3px
        border: 3px solid $pink-1
        border-top: none
        border-right: none
        background: transparent
        transform: rotate(-45deg)
    + span
      color: $black
      vertical-align: text-bottom
  input[type="radio"]
    visibility: hidden
    position: absolute
    left: -9999px
    &:checked
      &+.visual-radio:after
        opacity: 1
      &~span
        color: $black

.form-inline
  .form-group
    margin-right: 3px
    &:last-child
      margin-right: 0

.adunit
  overflow: hidden
  iframe
    width: 100%
    #document
      display: none

.pagination
  li
    a
      color: $brown
      &:hover, &:active, &:focus
        background-color: $pink-1
        color: #fff
    &.active a
      background-color: $pink-1
      color: #fff

.has-dropdown
  position: relative
  &:hover
    .dropdown
      display: block
  .dropdown
    display: none
    position: absolute
    top: 100%
    z-index: 999
    list-style: none
    padding: 0
    background-color: #fff
    color: $black
    transform: translateX(-6px)
    +border-radius(0 0 3px 3px)
    width: 100%
    li
      width: 100%
      a
        color: $black-1
        padding: 16px 10px
        width: 100%
        display: inline-block

.settings-wrap
  padding: 30px 0
  .list-item
    padding: 10px 0
  .card
    .title
      font-size: $font-size-4
      color: $black
      padding-bottom: 6px
      border-bottom: 1px solid $hr
      margin-bottom: 10px
    p
      padding: 12px 0
    .form-group
      margin: 22px 0
      h4, h4 span
        font-size: 14px
        font-weight: bold
      label
        span
          font-size: 14px
        .email-status
          font-size: 12px
          margin-left: 6px
          &.unenabled
            color: $orange
          &.enabled
            color: $green
          &.status-lg
            font-size: 18px
            margin:
              top: 3px
              left: 0px
              bottom: 8px
      .btn-email-Valid
        span
          font-size: 12px
        i
          margin-left: 3px
      .info
        font-size: 12px
      .dropdown-toggle
        .caret
          margin-left: 3px
    .muti-input
      .input-group
        margin: 3px 0
        .input-group-btn
          button
            padding: 7px 13px

.modal-dialog, .modal--default
  .modal-title
    padding: 4px 0 1px 0
  .modal-header
    background: $black-1
    padding: 0
    text-align: center
    .logo
      display: inline-block
      width: 150px
      height: 33px
      margin: 10px 0 3px 0
      background:
        image: url(./assets/lightbox_logo.png)
        color: $black-1
        position: 50% 50%
        repeat: no-repeat

.model--badges
  .modal-dialog
    @media screen and (min-width: $breakpoint-lg)
      width: 60%
    @media screen and (max-width: $breakpoint-lg)
      width: 60%
    @media screen and (max-width: $breakpoint-md)
      width: 70%
    @media screen and (max-width: $breakpoint-sm)
      width: auto
      width: initial
  .modal-header
    border-bottom: none
  .modal-body
    padding: 0
    thead
      background-color: $brown-2
      background-color: rgba($brown-2, 0.6)
      line-height: 30px
      @media screen and (max-width: $breakpoint-sm)
        display: none
      th
        text-align: center
        border-bottom: 1px solid $border-light
    tbody
      line-height: 160%
      tr
        border-bottom: 1px solid $border-light
        @media screen and (max-width: $breakpoint-sm)
          border-bottom: 0
        &:hover
          background-color: $background
          background-color: rgba($background, 0.3)
        &:last-child
            border-bottom: 0
        td
          padding: 10px 12px
        .cell--badge-img
          padding: 10px 20px
          .badges-img
            +opacity(1)
            width: 80px
            height: 80px
            margin: 0 auto
            float: none
            box-shadow: 0px 0px 4px rgba($black, 0.3)
            background-color: #f7f7f7
          @media screen and (max-width: $breakpoint-sm)
            display: block
            .badges-img
              margin: 20px auto 6px auto
              width: 140px
              height: 140px
        .cell--badge-name
          min-width: 8em
          text-align: center
          font-weight: bold
          color: $black
          @media screen and (max-width: $breakpoint-sm)
            display: block
            font-size: 1.3em
            margin-bottom: 40px
            padding: 0
            &:after
              content: ''
              display: block
              margin: 0 auto
        .cell--badge-desc
          color: $black
          font-size: 13px
          @media screen and (max-width: $breakpoint-sm)
            display: block
            padding: 20px
            line-height: 200%
            border: 1px solid $border-light
            margin: 0 20px 10px 20px

#submissionPopup
  table
    width: 100%
  .modal-header
    background-color: $black-1
    color: $yellow
    font-weight: bold
  .modal-body
    // background-color: $background
    td
      color: $black
      font-weight: bold
      display: block
      text-align: center
    td + td
      color: $yellow
      display: block
      font-size: 22px
      padding-bottom: 20px
      border-bottom: 1px solid #ddd
      margin: 10px auto 15px auto
      img
        margin-top: 10px
    tr
      &:last-child
        td + td
          border-bottom: 0
          padding-bottom: 0
  .modal-footer

table
  background-color: $white
  thead
    background-color: $white
    color: $grey
    &.bg-orange-pink
      background-color: $pink
      color: $grey
    &.bg-pink
      background-color: $pink-1
      color: $white
    tr
      th
        line-height: 44px !important
        text-align: center
        &.no-border
          border: none !important
  tbody
    tr
      text-align: center
      td
        border-top: 0 !important
        padding-top: 16px
        padding-bottom: 16px
        a
          color: $grey
.table-condensed>tbody>tr>td
  vertical-align: middle
.table-striped>tbody>tr:nth-of-type(odd)
  background-color: #F7F7F7 !important
.table-striped>tbody>tr:nth-of-type(even)
  background-color: #FBFBFB !important
i.glyphicon
  &.margin-right
    margin-right: 6px

.disable-caret-icon
  span.caret
    display: none
.dropdown-menu
  &--right-side
    left: inherit
    right: 0px
  &--auto-width
    min-width: 1rem
.disable-caret-icon
  .btn.btn-default
    border: none !important
    background-color: transparent !important
.button-no-shadow.btn-group.open
  .dropdown-toggle
    box-shadow: none

label.custom-switch input:checked + .slider
  background-color: $pink-1

.swal2-modal
  .swal2-title
    font-size: 24px
  .swal2-content
    font-size: 14px
    a, a:link, a:active, a:hover
      color: $pink-1
      text-decoration: underline
  .swal2-styled
    font-size: 14px
    padding: 8px 32px
  .swal2-confirm
    background: $pink-1 !important
  .swal2-cancel
    background: $brown-1 !important
</style>



// WEBPACK FOOTER //
// src/app.vue